export default {
    data() {
        return {
            validationResult: [],
            rules: {
                'required': (val,[],type) => {
                    if(type === 'file') {
                        if (!val) {
                            return 'Please select a file'
                        } else {
                            return null
                        }
                    } else if(type === 'select') {
                        if ((val == null || val.toString().trim() === '') && val !== 0) {
                            return 'Please Choose a option'
                        } else {
                            return null
                        }
                    } else {
                        if (val == null || val.toString().trim() === '') {
                            return 'This input is required.'
                        } else {
                            return null
                        }
                    }
                },
                'max':(val,[len])=>{
                    if (val == null || val === '') return null
                    if (this.$parent.$filters.characterByte(val) > len) {
                        return 'Valid up to '+ len + ' characters'
                    } else {
                        return null
                    }
                },
                'min':(val,[len])=> {
                    if (val == null || val === '') return null
                    if (this.$parent.$filters.characterByte(val) < len) {
                        return 'Valid from at least '+len+' characters'
                    } else {
                        return null
                    }
                },
                'minMax' : (val,[min,max])=>{
                    if (val == null || val === '') return null
                    if (this.$parent.$filters.characterByte(val) <= max && this.$parent.$filters.characterByte(val) >= max) {
                        return null
                    } else {
                        if(min === max) return 'Must be '+min+' characters'
                        return 'Valid from '+min+ ' to '+max+' characters'
                    }
                },
                'email':(val) => {
                    let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    if (!regex.test(val)) {
                        return 'Please enter a valid email format'
                    } else {
                        return null
                    }
                },
                'number':(val) => {
                    let regex = /^[1-9][0-9]*$/
                    if (!regex.test(val)) {
                        return 'Only numbers are allowed.'
                    } else {
                        return null
                    }
                },
                'phone':(val) => {
                    let regex = /^[0-9][0-9]*$/
                    if (!regex.test(val)) {
                        return 'Only numbers are allowed.'
                    } else {
                        return null
                    }
                },
                'fileType':(val,[fileType]) => {
                    if(val) {
                        let array = val.name.split('.')
                        let fileExt = array[array.length -1]
                        if(fileType === fileExt) {
                            return null
                        } else {
                            return 'Only '+fileType+' file available.'
                        }
                    } else {
                        return null
                    }
                },
                'symbol':(val,[])=>{
                    if (val == null || val === '') return null
                    let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z\d!@#$%^&*]{10,}$/
                    if (!regex.test(val)) {
                        return 'Please enter at least one letter, one digit and one special-character, and minimum length should be 10 characters.'
                    } else {
                        return null
                    }
                },
            },
        }
    },
    methods: {
        ruleCheck: function(name,value,args,type) {
            if(this.rules[name]) return this.rules[name](value,args,type)
        },
        getValidationResult: function(rules,inputValue,type) {
            let ruleArray = rules? rules.split(' '): []
            let validationResult = []
            ruleArray.forEach((item)=>{
                let [name,...args] = item.split(':')
                let result = this.ruleCheck(name,inputValue,args,type)
                if(result) {
                    validationResult.push(result)
                }
            })
            return validationResult
        },
        validationCheck: function(validGroup) {
            this.validationResult = []
            let validation = true
            let checkList = this.$children
            if(validGroup) {
                checkList = this.$children.filter(item=> (item.validGroup === validGroup || !item.validGroup))
            }
            for(let index in checkList) {
                if(checkList[index].validator) {
                    let result = checkList[index].validator()
                    if(result.length > 0 ) validation = false
                }
            }
            return validation
        },
        resetValidationResult: function () {
            console.log("validation.reset call")
            this.validationResult = []
        }
    },
}
